import { Controller } from "@hotwired/stimulus"
import { track } from "./analytics"

export default class extends Controller {
  static targets = [
    "item",
    "submit",
    "autofocus",
    "categoryGroup",
    "categoryCheckbox",
    "subCategory",
    "items"
  ]

  toggle() {
    if (this.isDropdownOpened) {
      this.filterBackdrop.classList.add(this.classes)
    } else {
      this.filterBackdrop.classList.remove(this.classes)
    }
    this.itemTarget.classList.toggle(this.classes)

    if (this.isDropdownOpened) {
      if (this.hasAutofocusTarget) {
        this.autofocusTarget.focus()
      }

      if (this.hasTracking) {
        track("Opened Filters", { filter_group: this.trackingName })
      }
    }
  }

  hide(event) {
    if (this.element.contains(event.target) || !this.isDropdownOpened) { return }

    let closeBackdrop = true
    // Check if the click is in a dropdown filter
    document.querySelectorAll('.search-dropdown').forEach(element => {
      if (element.contains(event.target)) {
        closeBackdrop = false
        return
      }
    })

    if (closeBackdrop) {
      this.filterBackdrop.classList.add(this.classes)

      if (event.target !== this.moreFiltersButton && this.hasSubmitTarget) {
        this.submitTarget.click()
      }
    }

    this.itemTarget.classList.add(this.classes)
  }

  handleKeyPressed(e) {
    if (this.isDropdownOpened && e.keyCode === 13) {
      this.submitTarget.click()
    }
  }

  toggleCategory(event) {
    const group = this.categoryGroupTargets.find(group => group.contains(event.currentTarget))
    if (!group) return

    if (this.categoryCheckboxTargets.find(cb => group.contains(cb)).checked) {
      this.itemsTargets.find(items => group.contains(items)).classList.remove("d-none")
    } else {
      this.itemsTargets.find(items => group.contains(items)).classList.add("d-none")
      this.subCategoryTargets.filter(cb => group.contains(cb)).forEach(cb => {
        cb.checked = false
      })
    }

    this.updateCategoryName(group)
  }

  subCategoryChanged(event) {
    const group = this.categoryGroupTargets.find(group => group.contains(event.currentTarget))
    if (!group) return

    const categoryCheckbox = this.categoryCheckboxTargets.find(cb => group.contains(cb))

    if (event.currentTarget.checked && !categoryCheckbox.checked) {
      categoryCheckbox.checked = true
      this.itemsTargets.find(items => group.contains(items)).classList.remove("d-none")
    }

    this.updateCategoryName(group)
  }


  updateCategoryName(group) {
    const categoryCheckbox = this.categoryCheckboxTargets.find(cb => group.contains(cb))
    if (this.subCategoryTargets.filter(cb => group.contains(cb)).some(cb => cb.checked)) {
      categoryCheckbox.removeAttribute("name")
    } else {
      categoryCheckbox.setAttribute("name", "activity_categories[]")
    }
  }

  // private

  get isDropdownOpened() {
    return !this.itemTarget.classList.contains(this.classes)
  }

  get hasTracking() {
    return this.data.has("tracking")
  }

  get trackingName() {
    return this.data.get("tracking")
  }

  get classes() {
    return this.data.get("classes")
  }

  get filterBackdrop() {
    return document.getElementById('filters-backdrop')
  }

  get moreFiltersButton() {
    return document.getElementById('js-more-filters-button')
  }

  get relatedFilter() {
    return document.getElementById(this.data.get("relatedFilter"))
  }
}
